import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { map } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import { unicodeToString, shuffle, dynamicSort } from "../../../Js/Common";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PauseIcon from "@mui/icons-material/Pause";
import AudioButton from "../../../Components/Media/AudioButton";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const MATCH = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [sideA, setSideA] = useState([]);
  let [sideB, setSideB] = useState([]);
  let [aHeight, setAHeight] = useState([]);
  let [bHeight, setBHeight] = useState([]);
  let [dragged, setDragged] = useState(false);
  let [logObj, setLogObj] = useState(initLogObj);
  let [isPlayingA, setIsPlayingA] = useState([]);
  let [isPlayingB, setIsPlayingB] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      setSideA(props.content.epage.options.content.sideA);
      setIsPlayingA(
        new Array(props.content.epage.options.content.sideA.length).fill(false)
      );
      //setSideB(props.content.epage.options.content.sideB);

      let tempArr = [...props.content.epage.options.content.sideB];
      let actualAnswersWithid = tempArr.map((val, index) => {
        let obj = {
          ...val,
          id: index,
        };
        return obj;
      });
      dispatch(currentAssetSliceActions.setCurrentAttemptData(null));

      let actAns = map(actualAnswersWithid, "id");
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actAns,
      });

      let shuffleArr = [];
      do {
        shuffleArr = shuffle(actualAnswersWithid);
      } while (actAns.join(",") == map(shuffleArr, "id").join(","));
      
      setSideB(shuffleArr);
      setIsPlayingB(
        new Array(props.content.epage.options.content.sideB.length).fill(false)
      );
      setDragged(false);

      //   let actualAnswers = props.content.epage.options.content.map((val) => {
      //     if (val.answer) return JSON.parse(val.answer);
      //     else return JSON.parse("false");
      //   });
      //   setLogObj({
      //     ...logObj,
      //     assetType: {
      //       ...logObj.assetType,
      //       value: props.content.info.asset_type_alias,
      //     },
      //     actualAnswer: actualAnswers,
      //   });
    }

    return () => {
      setAHeight([]);
      setBHeight([]);
      setSideA([]);
      setSideB([]);
    };
  }, [props.content]);

  useEffect(() => {
    setHeightAFunction();
  }, [sideA]);

  useEffect(() => {
    setHeightBFunction();
  }, [sideB]);

  const setHeightAFunction = () => {
    let arr = [];
    sideA.forEach((val, index) => {
      if (document.getElementById(`A_${index}`)) {
        arr.push(
          document.getElementById(`A_${index}`).childNodes[0].clientHeight
        );
      }
    });
    setAHeight(arr);
  };

  const setHeightBFunction = () => {
    let arr1 = [];
    sideB.forEach((val, index) => {
      if (document.getElementById(`B_${index}`)) {
        arr1.push(
          document.getElementById(`B_${index}`).childNodes[0].clientHeight
        );
      }
    });
    setBHeight(arr1);
  };

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  useEffect(() => {
    updateUserAnswer();
  }, [sideB]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setCurrentAttemptData(null));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    setDragged(false);
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      let actual = [...sideB];
      actual = actual.sort(dynamicSort("id"));
      setSideB(actual);
    }
  }, [showAnswer, assetLogObj]);

  const updateUserAnswer = () => {
    if (!showAnswer && !attempted && dragged) {
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(map(sideB, "id"))
      );
    }
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    boxShadow: isDragging ? "4px 4px 10px 0px #E5E5E5" : "",
    ...draggableStyle,
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination || showAnswer || attempted) {
      return;
    }

    const items = reorder(sideB, result.source.index, result.destination.index);

    setSideB(items);
    setDragged(true);
  };

  const setPlayMode = (status, index, side, end) => {
    let arr1 = new Array(props.content.epage.options.content.sideA.length).fill(
      false
    );
    let arr2 = new Array(props.content.epage.options.content.sideB.length).fill(
      false
    );
    if (status == true && side == "A" && !end && !isPlayingA[index]) {
      arr1[index] = status;
      setIsPlayingA(arr1);
      setIsPlayingB(arr2);
    }
    if (status == true && side == "B" && !end && !isPlayingB[index]) {
      arr2[index] = status;
      setIsPlayingA(arr1);
      setIsPlayingB(arr2);
    }

    if (side == "A" && isPlayingA[index]) {
      setIsPlayingA(arr1);
    }
    if (side == "B" && isPlayingB[index]) {
      setIsPlayingB(arr2);
    }

    if (end) {
      setIsPlayingA(arr1);
      setIsPlayingB(arr2);
    }
  };

  return (
    <Grid container gap={1}  >
      <Grid item xs={5}>
        {sideA &&
          sideA.map((val, index) => {
            return (
              <Box
                dense
                sx={{
                  border:
                    (val.media &&
                      (val.media.audio ||
                        val.media.image ||
                        val.media.video)) ||
                    unicodeToString(val.text).trim()
                      ? 1
                      : 0,
                  borderColor: "#EFEFEF",
                  padding: 0,
                  my: 2,
                  borderRadius: 10,
                  height:
                    +aHeight[index] < +bHeight[index]
                      ? +bHeight[index]
                      : +aHeight[index],
                }}
                id={`A_${index}`}
              >
                <List dense sx={{ py: 0 }}>
                  <ListItem sx={{ pa: 0 }}>
                    {val && val.media && (
                      <OptionMedia
                        media={val.media}
                        isPlaying={isPlayingA[index]}
                        setPlayMode={(status, end) => {
                          setPlayMode(status, index, "A", end);
                        }}
                      ></OptionMedia>
                    )}
                    <ListItemText
                      classes={{ primary: classes.ListItemText }}
                      sx={{ color: "primary.main", pr: 1, py: 0 }}
                    >
                      {val.text && (
                        <Typography
                          sx={{
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                        >
                          {unicodeToString(val.text)}
                        </Typography>
                      )}
                    </ListItemText>
                  </ListItem>
                </List>
              </Box>
            );
          })}
      </Grid>
      <Grid item xs={5}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {sideB &&
                  sideB.map((item, index1) => (
                    <Draggable
                      key={`${index1}_id`}
                      draggableId={`${index1}_options`}
                      index={index1}
                    >
                      {(provided, snapshot) => (
                        <Box
                          dense
                          sx={{
                            border: 1,
                            borderColor: "#EFEFEF",
                            padding: 0,
                            my: 2,
                            borderRadius: 10,
                            cursor: "pointer",
                            height:
                              +bHeight[index1] < +aHeight[index1]
                                ? +aHeight[index1]
                                : +bHeight[index1],
                          }}
                          id={`B_${index1}`}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <List dense sx={{ py: 0 }}>
                            <ListItem sx={{ pa: 0, alignSelf: "center" }}>
                              {optionWiseAns && optionWiseAns.length > 0 && (
                                <ListItemIcon>
                                  <StatusIndicator
                                    correct={optionWiseAns[index1]}
                                  ></StatusIndicator>
                                </ListItemIcon>
                              )}
                              {item && item.media && (
                                <OptionMedia
                                  media={item.media}
                                  isPlaying={isPlayingB[index1]}
                                  setPlayMode={(status, end) => {
                                    setPlayMode(status, index1, "B", end);
                                  }}
                                ></OptionMedia>
                              )}
                              <ListItemText
                                classes={{ primary: classes.ListItemText }}
                                sx={{ color: "primary.main", pr: 1, py: 0 }}
                              >
                                {item.text && (
                                  <Typography
                                    sx={{
                                      fontSize: "0.9rem",
                                      fontWeight: "500",
                                      "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                      },
                                    }}
                                  >
                                    {unicodeToString(item.text)}
                                  </Typography>
                                )}
                              </ListItemText>
                              {/* <ListItemIcon>
                            <DragIndicatorIcon
                              sx={{ color: "#EFEFEF", fontSize: "1.6rem",'@media (min-width: 1636px)': {
                                fontSize: '2.4rem',
                              } }}
                            />
                          </ListItemIcon> */}
                            </ListItem>
                          </List>
                        </Box>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "62vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default MATCH;
